// extracted by mini-css-extract-plugin
export default {"checkbox-container":"styles_checkbox-container__wO15q","checkbox_active":"styles_checkbox_active__YHV-o"};